
import { Component, Vue, Watch } from 'vue-property-decorator'

// Comment in for language support
/*
import {
    // RUSSIAN,
    // ENGLISH,
    ESTONIAN
} from '@/commons/constants/locale'
import { settingsStore } from '@/store'
 */

import {
    userStore,
    authenticationStore,
    AuthenticationService
    , errorStore
} from '@/store'
import User from '@/store/modules/user'
import ModalBoxUntrustedAuthentication from '@/commons/components/modal-box/ModalBoxUntrustedAuthentication.vue'
import $ from 'jquery'
import { RouterUtils } from '@/commons/utils/router'

@Component({
    components: {
        ModalBoxUntrustedAuthentication
    }
})
export default class AppHeader extends Vue {
    get hasErrors () {
        return errorStore.getIsError
    }

    @Watch('hasErrors')
    isErrorChanged (newValue: boolean) {
        if (newValue) {
            this.closeLoginModal()
        }
    }

    get userStore (): User {
        return userStore
    }

    get isLoginPage (): boolean {
        return this.$route.name === 'login'
    }

    // Comment in for language support
    /*
    get estonian(): string {
        return ESTONIAN
    }

    get english(): string {
        return ENGLISH
    }

    get russian(): string {
        return RUSSIAN
    }

    isCurrentLocale(value: string): boolean {
        return this.$i18n.locale === value
    }

    changeLocale(value: string): void {
        settingsStore.setLocale({ locale: value, localeContext: this.$i18n })
    }
     */

    get shouldShowUntrustedLoginButton (): boolean {
        const allowedEnvironments = ['localhost', 'dev', 'test']
        const environment = window.location.hostname.split('.').pop() || ''
        return !authenticationStore.isAuthenticated && allowedEnvironments.indexOf(environment) > -1
    }

    get isAuthenticated (): boolean {
        return authenticationStore.isAuthenticated
    }

    navigateToHomePageHandler (): void {
        if (this.$route.name && ['home', 'login'].includes(this.$route.name)) {
            return
        }
        this.$router.push('/', RouterUtils.setFocusToBody)
    }

    showLoginModal (): void {
        $('#untrustedAuthenticationModal').modal('show')
    }

    closeLoginModal (): void {
        $('#untrustedAuthenticationModal').modal('hide')
    }

    goToAccessibilityPage (): void {
        this.$router.push('/accessibility')
    }

    async logoutHandler (): Promise<void> {
        await AuthenticationService.logout()
        await this.$router.push(this.$route.path !== '/login' ? '/login' : '/', RouterUtils.setFocusToBody)
    }
}
